"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { Menu, X } from "lucide-react"
import { Button } from "../ui/button"
import { cn } from "@/lib/utils"
import AppointmentButton from "@/components/buttons/AppointmentButton";

const navigation = [
  { name: "Accueil", href: "/" },
  { name: "À propos", href: "/a-propos" },
  { name: "Services", href: "/services" },
  { name: "Blog", href: "/blog" },
  { name: "Contact", href: "/contact" },
]

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isMounted, setIsMounted] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <header className="sticky top-0 z-40 w-full border-b border-primary-100/80 bg-cream/90 py-4 backdrop-blur-md">
      <div className="container flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="font-serif text-xl tracking-tight">
          Marjory <span className="text-primary">Sophrologie</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navigation.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className={cn(
                "text-sm transition-colors hover:text-purple-600",
                pathname === item.href
                  ? "text-purple-600"
                  : "text-gray-700"
              )}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:block">
          <AppointmentButton size="sm" variant="outline">
            Réservez Maintenant
          </AppointmentButton>
        </div>

        {/* Mobile Menu Button */}
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden"
          aria-label="Toggle Menu"
        >
          {isMenuOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </Button>

        {/* Mobile Menu (ne s'affiche que quand le composant est monté) */}
        {isMounted && isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-white shadow-lg z-50 md:hidden border-t border-primary-100">
            <nav className="container flex flex-col py-4">
              {navigation.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={cn(
                    "py-2 transition-colors hover:text-purple-600",
                    pathname === item.href
                      ? "text-purple-600"
                      : "text-gray-700"
                  )}
                >
                  {item.name}
                </Link>
              ))}
              <AppointmentButton size="sm" variant="outline">
                Réservez Maintenant
              </AppointmentButton>
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}